import { NgClass } from '@angular/common';
import { inject, Injectable, OnDestroy } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RoutesRecognized,
} from '@angular/router';
import {
  BehaviorSubject,
  filter,
  Subject,
  Subscription,
  take,
  takeUntil,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderTitleService implements OnDestroy {
  private _headerTitle$ = new BehaviorSubject<string | undefined>(undefined);
  headerTitle$ = this._headerTitle$.asObservable();

  private routerEventsSubscription: Subscription;

  constructor(private router: Router, route: ActivatedRoute) {
    this.routerEventsSubscription = this.router.events
      .pipe(filter((event) => event instanceof RoutesRecognized))
      .subscribe((event) => {
        const route = event.state.root.firstChild;
        const data = route?.data;
        if (data?.['title']) {
          this._headerTitle$.next(data['title']);
        }
      });
  }

  setCustomTitle(title: string): void {
    this._headerTitle$.next(title);
  }

  ngOnDestroy(): void {
    this.routerEventsSubscription?.unsubscribe();
    this._headerTitle$.complete();
  }
}
